import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ProjectProposalForm.css';
import printWhiteSvg from 'images/print-white.svg';
import mailWhiteSvg from 'images/mail-white.svg';
import CheckBox from 'components/shared/checkbox/CheckBox';
import Button from 'components/shared/button/Button';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';
import { setShowEmailModal } from 'components/admin/projects/details/project-email-modal/store/actions';
import { updateProject } from 'components/admin/projects/creation/store/actions';
import { loadProjectRequest } from 'components/admin/projects/details/store/actions';
import { simpleScrollToTop } from 'services/utils/scroller-util';
import {
  getProjectProposal,
  getProjectProposalAddlItems,
  getProjectProposalItems,
  getProjectProposalForm,
  getCsiCodes,
  getItemDelete,
  getShowAwardRecommendation,
} from 'components/admin/projects/details/project-proposal/store/selectors';
import {
  buildProjectProposalForm,
  newItem,
  updateProjectProposalItemValue,
  updateProjectProposalSubItemValue,
  updateProjectProposalFormValue,
  createProjectProposal,
  updateProjectProposal,
  updateProjectProposalCostsShown,
  toggleCreateProposalSuccess,
  approveProjectProposal,
  toggleApproveProposalSuccess,
  resetProjectProposalItems,
  toggleAwardRecommendation,
  fetchSubcontractors,
  setShowLostModal,
  setShowCancelModal,
} from 'components/admin/projects/details/project-proposal/store/actions';
import {
  Table,
  Tooltip,
  OverlayTrigger,
  Button as ReactButton,
} from 'react-bootstrap';
import numeral from 'numeral';
import Number from 'components/shared/text/Number';
import ProjectProposalItem from 'components/admin/projects/details/project-proposal/ProjectProposalItem';
import ProjectProposalAddlItem from 'components/admin/projects/details/project-proposal/ProjectProposalAddlItem';

class ProjectProposalForm extends Component {
  constructor(props) {
    super(props);

    this.totalTradeCosts = 0;
  }

  resetFormItems = (proposal) => {
    const { projectProposal, dispatch } = this.props;
    dispatch(resetProjectProposalItems());
    dispatch(buildProjectProposalForm(projectProposal));
  };

  handleItemAdd = () => {
    this.props.dispatch(newItem(this.props.projectProposalItems));
  };

  buildFeeAndInsurance = (oldTradeCosts, newTradeCosts) => {
    const { insuranceRatio, feeRatio } = this.props.projectProposalForm;
    const totalCost = this.totalTradeCosts - oldTradeCosts + newTradeCosts;
    this.handleAdditionalItemChange('insurance', totalCost * insuranceRatio);
    this.handleAdditionalItemChange('fee', totalCost * feeRatio);
  };

  handleRatioChange = (attr, ratio, value) => {
    if (ratio) {
      this.handleAdditionalItemChange(`${attr}Ratio`, ratio);
      this.handleAdditionalItemChange(attr, this.totalTradeCosts * ratio);
    } else {
      this.handleAdditionalItemChange(
        `${attr}Ratio`,
        this.totalTradeCosts ? value / this.totalTradeCosts : 1
      );
    }
  };

  handleItemChange = (key, attribute, value) => {
    if (attribute === 'tradeCosts') {
      const { projectProposalItems } = this.props;
      const item = projectProposalItems[key];
      this.buildFeeAndInsurance(item.tradeCosts, value);
    }

    this.props.dispatch(updateProjectProposalItemValue(key, attribute, value));
  };

  handleSubItemChange = (itemKey, subItemKey, attribute, value) => {
    if (attribute === 'tradeCosts') {
      const { projectProposalItems } = this.props;
      const subItem = projectProposalItems[itemKey].subItems[subItemKey];
      this.buildFeeAndInsurance(subItem.tradeCosts, value);
    }

    this.props.dispatch(
      updateProjectProposalSubItemValue(itemKey, subItemKey, attribute, value)
    );
  };

  handleAwardRecommendationChange = (key, id, name) => {
    this.handleItemChange(key, 'awardRecommendationId', id);
    this.handleItemChange(key, 'awardRecommendationName', name);
  };

  handleAdditionalItemChange = (attribute, value) => {
    this.props.dispatch(updateProjectProposalFormValue(attribute, value));
  };

  handleSave = () => {
    const {
      projectProposalForm,
      projectProposalItems,
      projectProposalAddlItems,
    } = this.props;
    const form = projectProposalForm;
    form.projectProposalItems = Object.keys(projectProposalItems)
      .map((key) => {
        const item = projectProposalItems[key];
        item.subItems = Object.keys(item.subItems || {}).map(
          (subItemKey) => item.subItems[subItemKey]
        );
        return item;
      })
      .filter((item) => !!item.csiCodeId);

    ['permits', 'generalConditions', 'insurance', 'fee', 'contingency'].forEach(
      (attr) => {
        form[`${attr}Items`] = Object.keys(projectProposalAddlItems[attr]).map(
          (key) => projectProposalAddlItems[attr][key]
        );
      }
    );

    if (this.props.projectProposal === null) {
      this.props
        .dispatch(createProjectProposal(this.props.currentProject.id, form))
        .then((response) => {
          this.resetFormItems(response.projectProposal);
          this.props.dispatch(toggleCreateProposalSuccess());
          this.props.onToggleReadOnly();
        });
    } else {
      this.props
        .dispatch(updateProjectProposal(this.props.currentProject.id, form))
        .then((response) => {
          this.resetFormItems(response.projectProposal);
          this.props.onToggleReadOnly();
        });
    }
  };

  handleApprove = () => {
    this.props
      .dispatch(approveProjectProposal(this.props.currentProject.id))
      .then(() => this.props.dispatch(toggleApproveProposalSuccess()));
  };

  handleToggleAwardRecommendation = () => {
    Object.keys(this.props.projectProposalItems).forEach((key) => {
      this.handleAwardRecommendationChange(key, null, null);
    });
    this.props.dispatch(toggleAwardRecommendation());
  };

  handleCancel = () => {
    this.resetFormItems(this.props.projectProposal);
    this.props.onToggleReadOnly();
  };

  loadSubcontractors = (input, csiCodeId, page) => {
    return this.props
      .dispatch(fetchSubcontractors(input, csiCodeId, page))
      .then((response) => {
        if (response.ok) {
          const companies = response.contractors;
          return {
            ok: true,
            options: companies.map((element) => {
              return {
                value: element.id,
                label: element.name,
              };
            }),
            hasMore: true,
          };
        }
      });
  };

  selectedCsiCodes = () => {
    return Object.keys(this.props.projectProposalItems)
      .filter((key) => !this.props.projectProposalItems[key].delete)
      .map((key) => this.props.projectProposalItems[key].csiCodeId);
  };

  csiCodeOptions = () => {
    const selectedCsiCodes = this.selectedCsiCodes();
    return this.props.csiCodes
      .filter((csiCode) => !selectedCsiCodes.includes(csiCode.id))
      .map((csiCode) => ({ value: csiCode.id, label: csiCode.division }));
  };

  totalItemCost = (item) => {
    let cost = numeral(item.tradeCosts).value();
    item.subItems &&
      Object.keys(item.subItems).forEach((key) => {
        const subItem = item.subItems[key];
        if (!subItem.delete) {
          cost += numeral(subItem.tradeCosts).value();
        }
      });
    return cost;
  };

  mapItems = (costsShown) => {
    this.totalTradeCosts = 0;
    const csiCodeOptions = this.csiCodeOptions();
    const items = Object.keys(this.props.projectProposalItems)
      .filter((key) => !this.props.projectProposalItems[key].delete)
      .map((key) => {
        const item = this.props.projectProposalItems[key];
        this.totalTradeCosts += this.totalItemCost(item);

        return (
          <ProjectProposalItem
            key={key}
            itemKey={key}
            item={item}
            itemDelete={this.props.itemDelete[key]}
            costsShown={costsShown}
            readOnly={this.props.readOnly}
            showAwardRecommendation={this.props.showAwardRecommendation}
            onCsiCodeOptions={this.csiCodeOptions}
            onTotalItemCost={this.totalItemCost}
            onLoadSubcontractors={this.loadSubcontractors}
            onChange={this.handleItemChange}
            onSubItemChange={this.handleSubItemChange}
          />
        );
      });

    if (!this.props.readOnly && csiCodeOptions.length > 0) {
      items.push(
        <tr key="add-row">
          <td />
          <td>
            <div className="tomato-row add-row" onClick={this.handleItemAdd}>
              <div className="add-row-message">
                <span className="add-row-plus">+ </span>Add Row
              </div>
            </div>
          </td>
          <td />
          <td />
          <td />
          <td />
        </tr>
      );
    }

    if (costsShown) {
      items.push(
        <tr key="total-costs">
          <td />
          <td />
          <td>
            <div className="tomato-row">TOTAL TRADE COSTS</div>
          </td>
          <td>
            <div className="tomato-row">
              <Number value={this.totalTradeCosts} format="$ 0,0" />
            </div>
          </td>
          <td>
            <div className="tomato-row">
              <Number
                value={
                  this.totalTradeCosts / this.props.currentProject.sq_footage
                }
                format="$ 0,0.[00]"
              />
            </div>
          </td>
          <td />
        </tr>
      );
    }

    return items;
  };

  totalAddlItemCost = (attr) => {
    const { projectProposalAddlItems } = this.props;
    const form = this.props.projectProposalForm;
    const addlItems = projectProposalAddlItems[attr];
    let cost = numeral(form[attr]).value();
    addlItems &&
      Object.keys(addlItems).forEach((key) => {
        const item = addlItems[key];
        if (!item.delete) {
          cost += numeral(item.cost).value();
        }
      });
    return cost;
  };

  mapAdditionalItems = () => {
    const { projectProposalAddlItems, readOnly } = this.props;
    const form = this.props.projectProposalForm;
    let total = 0;
    const addlItems = [
      ['permits', 'Permits (Allowance)'],
      ['generalConditions', 'General Conditions'],
      ['insurance', 'Insurance'],
      ['fee', 'Fee'],
      ['contingency', 'Contingency'],
    ].map((attr) => {
      const itemRatio = form[`${attr[0]}Ratio`];
      const itemTotalCost = this.totalAddlItemCost(attr[0]);
      total += itemTotalCost;
      return (
        <ProjectProposalAddlItem
          key={attr[0]}
          itemKey={attr[0]}
          itemValue={form[attr[0]]}
          itemTitle={attr[1]}
          itemTotalCost={itemTotalCost}
          itemRatio={itemRatio}
          subItems={projectProposalAddlItems[attr[0]]}
          readOnly={readOnly}
          onRatioChange={this.handleRatioChange}
          onChange={this.handleAdditionalItemChange}
        />
      );
    });

    addlItems.push(
      <tr key="total-addl-costs">
        <td />
        <td />
        <td>
          <div className="tomato-row">TOTAL COST</div>
        </td>
        <td>
          <div className="tomato-row">
            <Number value={total + this.totalTradeCosts} format="$ 0,0" />
          </div>
        </td>
        <td>
          <div className="tomato-row">
            <Number
              value={
                (total + this.totalTradeCosts) /
                this.props.currentProject.sq_footage
              }
              format="$ 0,0.[00]"
            />
          </div>
        </td>
        <td />
      </tr>
    );

    return addlItems;
  };

  handleCostsToggleChange = () => {
    const {
      currentProject,
      projectProposal,
      projectProposalForm,
      dispatch,
    } = this.props;
    const costsShown = !projectProposalForm.costsShownToPrimary;
    this.handleAdditionalItemChange('costsShownToPrimary', costsShown);
    projectProposal &&
      dispatch(updateProjectProposalCostsShown(currentProject.id, costsShown));
  };

  renderCostsToggleTooltip = () => {
    return (
      <Tooltip id="tooltip-costs-toggle">
        Show Costs to Primary Users (Clients, Architects, etc.)
      </Tooltip>
    );
  };

  renderCostsToggle = () => {
    const form = this.props.projectProposalForm;
    return (
      <OverlayTrigger
        placement="right"
        overlay={this.renderCostsToggleTooltip()}
      >
        <ReactButton className="checkbox-button">
          <CheckBox
            checked={form.costsShownToPrimary}
            size="medium"
            onChange={this.handleCostsToggleChange}
          />
        </ReactButton>
      </OverlayTrigger>
    );
  };

  handleShowEmailModal = () => {
    this.props.dispatch(setShowEmailModal(true));
  };

  handleShowLostModal = () => {
    this.props.dispatch(setShowLostModal(true));
  };

  handleUpdateStatus = (status) => {
    const projectId = this.props.currentProject.id;
    this.props
      .dispatch(updateProject(projectId, { status: status }))
      .then((response) => {
        if (response.ok) {
          this.props.dispatch(loadProjectRequest(projectId));
          simpleScrollToTop();
        }
      });
  };

  handleMobilize = () => {
    this.handleUpdateStatus('in_progress');
  };

  handleClose = () => {
    this.handleUpdateStatus('complete');
  };

  handleShowCancelModal = () => {
    this.props.dispatch(setShowCancelModal(true));
  };

  render() {
    const { projectProposal } = this.props;
    const costsShown = !projectProposal || projectProposal.costs_shown;
    const headers = [
      '',
      'DIVISION',
      'SUMMARY',
      costsShown ? 'TRADE COSTS' : '',
      costsShown ? '/SF' : '',
      <span>
        AWARD RECOMMENDATION&nbsp;
        {!this.props.readOnly && (
          <span
            className="hide-award-reccomendation"
            onClick={this.handleToggleAwardRecommendation}
          >
            {this.props.showAwardRecommendation ? '(-)' : '(+)'}
          </span>
        )}
      </span>,
    ];
    return (
      <div className="project-proposal-form">
        <div className="project-proposal-form-header">
          <h3 className="form-title">
            {costsShown ? 'Costs' : 'Work'} Breakdown
          </h3>
          {this.props.showActions && this.renderCostsToggle()}
        </div>

        {this.props.csiCodes && this.props.csiCodes.length > 0 && (
          <Table className="projects-table form-costs-breakdown-table">
            {headers.length > 0 && (
              <colgroup>
                {headers.map((_, index) => {
                  return <col key={index + 1} />;
                })}
              </colgroup>
            )}
            {headers.length > 0 && (
              <thead>
                <tr>
                  {headers.map((element, index) => {
                    if (typeof element === 'string') {
                      return (
                        <th key={index}>
                          <span>{element}</span>
                        </th>
                      );
                    } else {
                      return <th key={index}>{element}</th>;
                    }
                  })}
                </tr>
              </thead>
            )}
            <tbody>{this.mapItems(costsShown)}</tbody>
          </Table>
        )}

        {costsShown && (
          <div>
            <hr />
            <h3 className="form-title">Total Trade Costs</h3>
            <Table className="projects-table form-costs-breakdown-table">
              <colgroup>
                {headers.map((_, index) => {
                  return <col key={index + 1} />;
                })}
              </colgroup>
              <tbody>{this.mapAdditionalItems()}</tbody>
            </Table>
          </div>
        )}

        <div className="project-proposal-buttons">
          {!this.props.readOnly && (
            <div className="buttons-container">
              <Button
                className="button button-orange"
                label="Save Changes"
                onClick={this.handleSave}
              />
              {this.props.projectProposal && (
                <Button
                  className="button button-gray"
                  label="Cancel"
                  onClick={this.handleCancel}
                />
              )}
            </div>
          )}
          {this.props.projectProposal &&
            this.props.readOnly &&
            this.props.showActions && (
              <div className="buttons-container-actions">
                {this.props.showApprove && (
                  <Button
                    className="button button-white"
                    label="Approve"
                    onClick={this.handleApprove}
                  />
                )}
                {this.props.showCancel && (
                  <Button
                    className="button button-white"
                    label="Cancelled"
                    onClick={this.handleShowCancelModal}
                  />
                )}
                {this.props.showLost && (
                  <Button
                    className="button button-white"
                    label="Lost"
                    onClick={this.handleShowLostModal}
                  />
                )}
                {this.props.showMobilize && (
                  <Button
                    className="button button-white"
                    label="Mobilize"
                    onClick={this.handleMobilize}
                  />
                )}
                {this.props.showClose && (
                  <Button
                    className="button button-white"
                    label="Project Complete"
                    onClick={this.handleClose}
                  />
                )}
              </div>
            )}
          {this.props.projectProposal &&
            this.props.readOnly &&
            this.props.showActions && (
              <div className="buttons-container">
                {!this.props.showApprove && (
                  <Button
                    className="btn button button-gray"
                    icon={mailWhiteSvg}
                    label="Email"
                    onClick={this.handleShowEmailModal}
                  />
                )}

                <Button
                  className="button button-gray"
                  icon={printWhiteSvg}
                  label="View PDF"
                  onClick={this.props.onGeneratePdf}
                />
                <Button
                  className="button button-orange"
                  label="Edit"
                  onClick={this.props.onToggleReadOnly}
                />
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentProject: getCurrentProject(state),
    projectProposal: getProjectProposal(state),
    projectProposalAddlItems: getProjectProposalAddlItems(state),
    projectProposalItems: getProjectProposalItems(state),
    projectProposalForm: getProjectProposalForm(state),
    csiCodes: getCsiCodes(state),
    itemDelete: getItemDelete(state),
    showAwardRecommendation: getShowAwardRecommendation(state),
  };
})(ProjectProposalForm);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-proposal/ProjectProposalForm.js